import {
  Avatar,
  createStyles,
  Dialog,
  DialogContent,
  Grid,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useCleverlynkFunctions from "../../../hooks/useCleverlynkFunctions";
import useDisableOverflow from "../../../hooks/useDisableOverflow";
import { selectCompany, selectIsMobile, selectGetOrder } from "../../../redux/slices/cleverlynkSlice";
import { selectOpenedAuth, selectSavedIdentifications } from "../../../redux/slices/userFormSlice";
import PreviousEmails from "./PreviousEmails";

interface IAuthScreen {
  open: boolean;
  setClose: () => void;
}

const AuthScreen = ({ open, setClose }: IAuthScreen) => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const getOrder = useSelector(selectGetOrder);

  const company = useSelector(selectCompany);
  const emails = useSelector(selectSavedIdentifications);
  // const emails = [];
  const isMobile = useSelector(selectIsMobile);
  const openedAuth = useSelector(selectOpenedAuth);

  const theme = useTheme();

  const { enable, disable } = useDisableOverflow();

  useEffect(() => {
    if (getOrder.status === "succeeded") setClose();
    if (open && !openedAuth && emails.length > 0) {
      if (emails.length === 0) {
        setCollapsed(true);
      }
      disable();
    } else enable();
  }, [open, emails, openedAuth, getOrder]);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      dialogRoot: {
        //@ts-ignore
        zIndex: "1302 !important",
      },
      dialogPaper: {
        maxWidth: 420,
        width: "96%",
        minHeight: "60%",
        margin: 15,
        marginTop: 70,
      },
      companyAvatarDiv: {
        marginBottom: 50,
        marginTop: 30,
        transitionDuration: "400ms",
        transitionProperty: "margin-top, margin-bottom",
        "&.collapsed": {
          marginBottom: 20,
          marginTop: 10,
        },
      },
      companyAvatar: {
        height: 120,
        width: 120,
        boxShadow: "#dadada 1pt 1pt 3px 1px",
        transitionDuration: "400ms",
        transitionProperty: "height, width",
        "&.collapsed": {
          height: 80,
          width: 80,
        },
      },
    })
  );

  const classes = useStyles();

  return (
    <Dialog
      open={open && !openedAuth && emails.length > 0}
      onClose={setClose}
      classes={{ paper: classes.dialogPaper, root: classes.dialogRoot }}
      BackdropProps={{
        style: {
          backgroundColor: "#000000a1",
        },
      }}>
      <DialogContent>
        <Grid container direction="column" style={{ position: "relative" }}>
          <Grid
            item
            container
            direction="column"
            alignContent="center"
            className={`${collapsed ? "collapsed" : ""} ${classes.companyAvatarDiv}`}>
            <Grid item container justifyContent="center">
              <Avatar
                className={`${collapsed ? "collapsed" : ""} ${classes.companyAvatar}`}
                variant="circular"
                src={company?.logoUrl}
              />
            </Grid>
            <Grid item container justifyContent="center" style={{ marginTop: 20 }}>
              <Typography>{company?.name}</Typography>
            </Grid>
          </Grid>
          <Grid item container justifyContent="center" alignItems="center">
            <PreviousEmails
              emails={emails}
              closeDialog={setClose}
              collapsed={collapsed}
              toggleCollapsed={() => setCollapsed(p => !p)}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AuthScreen;
